import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector,
} from '@angular/core';
import { ColorEditorOverlayComponent } from './color-editor-overlay.component';

@Injectable({ providedIn: 'root' })
export class ColorEditorOverlayService {
  constructor(
    private appRef: ApplicationRef,
    private injector: Injector,
    private cfr: ComponentFactoryResolver,
  ) {}

  open(initial: string[]): Promise<string[] | null> {
    return new Promise(resolve => {
      const factory = this.cfr.resolveComponentFactory(
        ColorEditorOverlayComponent,
      );
      const compRef = factory.create(this.injector);
      compRef.instance.initialColors = initial || [];
      compRef.instance.done.subscribe((result: string[] | null) => {
        resolve(result);
        this.destroy(compRef);
      });
      this.appRef.attachView(compRef.hostView);
      document.body.appendChild((compRef.location as any).nativeElement);
    });
  }

  private destroy<T>(compRef: ComponentRef<T>) {
    try {
      this.appRef.detachView(compRef.hostView);
    } catch {}
    try {
      compRef.destroy();
    } catch {}
  }
}
